import React from 'react'
import { useDarkMode } from '../../contexts/DarkModeContext';
import BlogCard from '../../components/BlogCard/BlogCard';
import AdCMP from '../../components/ADS/AdCMP';

const adSlots = ["6784508920", "4229378215", "6200935433"];

const ResponsiveAd = ({ dataAdSlot }) => (
    <div className="w-full my-4">
        <div className='hidden xl:block'>
            <AdCMP adSize='728x90' dataAdSlot={dataAdSlot} />
        </div>
        <div className='hidden md:block xl:hidden'>
            <AdCMP adSize='468x60' dataAdSlot={dataAdSlot} />
        </div>
        <div className='block md:hidden'>
            <AdCMP adSize='320x50' dataAdSlot={dataAdSlot} />
        </div>
    </div>
);

function Blog() {
    const { gamesList } = useDarkMode();
    
    return (
        <div className="p-4 mt-12 sm:ml-56">
            <ResponsiveAd dataAdSlot="6200935433" />
            
            <h1 className='text-black dark:text-white font-bold text-lg'>Games Blogs</h1>
            
            <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-5 gap-4 mt-2">
                {gamesList && gamesList.map((_ele, i) => {
                    const GetSlug = _ele?.name?.en?.toLowerCase().replace(/\s+/g, "-");
                    const items = [];
                    
                    items.push(
                        <BlogCard
                            key={i}
                            id={i}
                            slug={GetSlug}
                            name={_ele?.name?.en}
                            banner={_ele?.assets?.cover}
                            link={_ele?.URL}
                            img={_ele?.assets?.square}
                            _ele={_ele}
                        />
                    );
                    
                    if ((i + 1) % 10 === 0) {
                        const randomSlot = adSlots[Math.floor(Math.random() * adSlots.length)];
                        items.push(
                            <div key={`ad-${i}`} className="col-span-full w-full">
                                <ResponsiveAd dataAdSlot={randomSlot} />
                            </div>
                        );
                    }
                    
                    return items;
                }).flat()}}
                {(!gamesList || gamesList.length === 0) && (
                    <div className="col-span-12 lg:col-span-12 rounded-lg bg-white w-full h-40 flex justify-center items-center my-4">
                        <h2 className="text-[28px] font-bold">No games found.</h2>
                    </div>
                )}
            </div>
            
            <ResponsiveAd dataAdSlot="4229378215" />
        </div>
    )
}

export default Blog